export default __webpack_public_path__ + "static/media/WF4.bfc08fc7.png";